import { Box, Menu, MenuItem } from '@mui/material';

type ActionMenuItem = {
    onClick: any;
    text: string;
    testID?: string;
};

interface ActionsMenuProps {
    anchorEl: any;
    menuOpen: any;
    closeMenu: any;
    menuItems: ActionMenuItem[];
}
const ActionsMenu = ({ anchorEl, menuOpen, closeMenu, menuItems = [] }: ActionsMenuProps) => (
    <Menu id="basic-menu" anchorEl={anchorEl} open={menuOpen} onClose={closeMenu}>
        <Box>
            {menuItems?.map((item: ActionMenuItem, index: number) => {
                const { onClick, text, testID } = item;
                return (
                    <MenuItem data-testid={testID || `item ${index}`} onClick={onClick}>
                        {text}
                    </MenuItem>
                );
            })}
        </Box>
    </Menu>
);

export { ActionsMenu };
